import React from 'react'
import { BsrsGrid, Column, actionButtonsColumnProps } from '@/components/BsrsGrid'
import Resx from '@/components/Resx'
import { Main, MainTop, MainTopTitle, MainTopLeft, MainBody } from '@/components/Layout'
import context from '@/context'
import { CreateChangeItem } from '@/components/changeRequests/createChangeItem'
import { useLocalization } from '@/hooks/localization'
import { getTargetUrl } from '@/components/changeRequests/urls'

function IndividualList () {
  const { localize } = useLocalization()
  return (
    <Main>
      <MainTop>
        <MainTopTitle>
          <Resx name='Individuals.Title' />
        </MainTopTitle>
        <MainTopLeft>
          <CreateChangeItem buttonText='Individuals.CreateNew' scope='Individuals' />
        </MainTopLeft>
      </MainTop>
      <MainBody>
        <BsrsGrid persistenceId={'individuals'} dataSource={context.api.individualService.getIndividuals}>
          <Column field='firstName' title={localize('Individuals.Name')} width='250px' />
          <Column field='fatherName' title={localize('Individuals.FatherName')} />
          <Column field='grandfatherName' title={localize('Individuals.GrandfatherName')} />
          <Column field='greatGrandfatherName' title={localize('Individuals.GreatGrandfatherName')} />
          <Column field='surname' title={localize('Individuals.Surname')} />
          <Column {...actionButtonsColumnProps([{ url: x => getTargetUrl('Individuals', x.id), icon: 'show' }])} />
        </BsrsGrid>
      </MainBody>
    </Main>
  )
}

export {
  IndividualList
}



// WEBPACK FOOTER //
// ./src/report-app/pages/individuals/index.js